import { render, staticRenderFns } from "./CALUHFAccessoryKit.vue?vue&type=template&id=73bdb7e2&scoped=true&lang=pug"
import script from "./CALUHFAccessoryKit.vue?vue&type=script&lang=js"
export * from "./CALUHFAccessoryKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bdb7e2",
  null
  
)

export default component.exports